/* PAT 7.2 / Bereich 17: Barrierefreiheit - Tastaturbedienung und Stopp-Knoepfe. */
(function () {
  "use strict";

  // a) Schliessen-Knoepfe der Schubfaecher mit der Tastatur erreichbar machen.
  function macheKnopfBedienbar(el) {
    if (!el || el.dataset.tpTastatur === "1") return;
    el.dataset.tpTastatur = "1";
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        el.click();
      }
    });
  }

  function tastaturNachruesten() {
    document.querySelectorAll("drawer-closer, [role='button']:not(button):not(a)").forEach(macheKnopfBedienbar);
  }

  // b) Escape schliesst jedes offene Schubfach, egal wo der Fokus steht.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var offen = document.querySelector("drawer-component[open]");
    if (offen && typeof offen.closeDrawer === "function") offen.closeDrawer();
  });

  // c) Stopp-Knopf fuer die laufende Ankuendigungsleiste und fuer Autoplay-Videos.
  function stoppKnopfBauen(ziel, beschriftungAn, beschriftungAus, anhalten, weiter) {
    var knopf = document.createElement("button");
    knopf.type = "button";
    knopf.className = "tp-stopp";
    knopf.textContent = beschriftungAn;
    knopf.setAttribute("aria-label", beschriftungAn);
    var laeuft = true;
    knopf.addEventListener("click", function () {
      laeuft = !laeuft;
      if (laeuft) {
        weiter();
        knopf.textContent = beschriftungAn;
        knopf.setAttribute("aria-label", beschriftungAn);
      } else {
        anhalten();
        knopf.textContent = beschriftungAus;
        knopf.setAttribute("aria-label", beschriftungAus);
      }
    });
    ziel.appendChild(knopf);
    return knopf;
  }

  function stoppKnoepfe() {
    document.querySelectorAll(".usp-band").forEach(function (band) {
      if (band.dataset.tpStopp === "1") return;
      band.dataset.tpStopp = "1";
      var track = band.querySelector(".usp-band__track");
      if (!track) return;
      stoppKnopfBauen(
        band,
        "Lauftext anhalten",
        "Lauftext fortsetzen",
        function () { track.style.animationPlayState = "paused"; },
        function () { track.style.animationPlayState = "running"; }
      );
    });

    document.querySelectorAll("video[autoplay]").forEach(function (video) {
      if (video.dataset.tpStopp === "1") return;
      video.dataset.tpStopp = "1";
      var huelle = video.parentElement;
      if (!huelle) return;
      stoppKnopfBauen(
        huelle,
        "Video anhalten",
        "Video abspielen",
        function () { video.pause(); },
        function () { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      );
    });
  }

  function karussellsBeschriften() {
    var vorher = (window.FoxThemeStrings && window.FoxThemeStrings.sliderPrevious) || 'Vorheriges Element';
    var nachher = (window.FoxThemeStrings && window.FoxThemeStrings.sliderNext) || 'Nächstes Element';
    document.querySelectorAll('.flickity-button.previous').forEach(function (knopf) {
      knopf.setAttribute('aria-label', vorher);
      knopf.setAttribute('title', vorher);
    });
    document.querySelectorAll('.flickity-button.next').forEach(function (knopf) {
      knopf.setAttribute('aria-label', nachher);
      knopf.setAttribute('title', nachher);
    });

    // Kopien in automatisch laufenden Baendern sind rein dekorativ. Falls
    // spaeter einmal verlinkte Inhalte eingesetzt werden, duerfen ihre Klone
    // trotzdem nicht ein zweites Mal in der Tab-Reihenfolge auftauchen.
    document
      .querySelectorAll('f-scrolling-promotion [aria-hidden="true"] a, f-scrolling-promotion [aria-hidden="true"] button')
      .forEach(function (element) {
        element.setAttribute('tabindex', '-1');
      });
  }

  function start() {
    tastaturNachruesten();
    stoppKnoepfe();
    karussellsBeschriften();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", start);
  window.setTimeout(start, 1500);

  // d) tom&pat 10.2 (Theo, 09.10.2026, Rundgang Aufgabe 59): Fokus-Falle der Warenkorb-Schublade (#Drawer-Cart).
  //    Die Falle des Themes (global.js trapFocus) merkt sich das erste und letzte Element beim Öffnen. Die Express-Knöpfe
  //    zeichnet Shopify erst danach (teils in eigenen Rahmen/Schatten-Bereichen): Tab sprang vom Kassenknopf zurück auf
  //    „Schließen“, und nach dem letzten Express-Knopf lief der Fokus auf die verdeckte Seite dahinter.
  //    Jetzt nur für diese Schublade: je ein unsichtbarer Fokus-Wächter vor und hinter dem Inhalt. Wer per Tab hinter das
  //    letzte Element kommt (auch aus einem PayPal-/Google-Rahmen heraus), landet wieder auf dem ersten; Shift+Tab vor dem
  //    ersten springt auf das letzte. Erstes/letztes Element werden bei jedem Wechsel neu ermittelt (nur sichtbare,
  //    einschließlich offener Schatten-Bereiche). Die Theme-Falle wird für diese Schublade abgemeldet (removeTrapFocus aus
  //    global.js), damit sie nicht mit veralteten Grenzen dazwischenfunkt. Escape schließt wie bisher (b); wurde die
  //    Schublade per Tastatur geschlossen und hat das Theme keinen Rückweg (z. B. nach „In den Warenkorb“), geht der
  //    Fokus auf das zuletzt benutzte Element der Seite zurück.
  var SCHUBLADE_ID = "Drawer-Cart";
  var FOKUSIERBAR = "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";
  var zuletztAussen = null;
  var perTastatur = false;
  var rueckwaerts = false;

  function offeneSchublade() {
    var s = document.getElementById(SCHUBLADE_ID);
    return s && s.hasAttribute("open") ? s : null;
  }

  function istSichtbar(el) {
    if (typeof el.checkVisibility === "function") return el.checkVisibility({ visibilityProperty: true });
    return el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== "hidden";
  }

  // Alle sichtbaren, per Tab erreichbaren Kandidaten in Reihenfolge, auch in offenen Schatten-Bereichen. Web-Komponenten
  // mit geschlossenem Schatten-Bereich (z. B. Shopifys Google-Pay- und Shop-Pay-Knopf) stehen als Kandidat mit drin;
  // ob sie den Fokus annehmen, zeigt erst der Versuch (fokusNach).
  function fokusListe(wurzel, liste) {
    liste = liste || [];
    var kinder = wurzel.children || [];
    for (var i = 0; i < kinder.length; i++) {
      var el = kinder[i];
      if (el.hasAttribute("data-tp-fokus-waechter") || el.inert) continue;
      var komponente = el.tagName.indexOf("-") > 0 && !el.shadowRoot;
      if (((el.matches(FOKUSIERBAR) && el.tabIndex >= 0) || komponente) && istSichtbar(el)) liste.push(el);
      if (el.shadowRoot) fokusListe(el.shadowRoot, liste);
      fokusListe(el, liste);
    }
    return liste;
  }

  function hatFokus(el) {
    var aktiv = document.activeElement;
    return aktiv === el || (aktiv && el.contains(aktiv)) || (el.getRootNode && el.getRootNode() !== document && el.getRootNode().activeElement === el);
  }

  function waechterSetzen(schublade) {
    if (schublade.querySelector(":scope > [data-tp-fokus-waechter]")) return;
    ["anfang", "ende"].forEach(function (art) {
      var w = document.createElement("span");
      w.setAttribute("tabindex", "0");
      w.setAttribute("data-tp-fokus-waechter", art);
      w.className = "visually-hidden";
      if (art === "anfang") schublade.insertBefore(w, schublade.firstChild);
      else schublade.appendChild(w);
    });
  }

  function themeFalleAbmelden() {
    if (typeof window.removeTrapFocus === "function") window.removeTrapFocus();
  }

  // Erstes bzw. letztes Element fokussieren; nimmt ein Kandidat den Fokus nicht an, ist der nächste dran.
  function fokusNach(schublade, ende) {
    var liste = fokusListe(schublade);
    if (ende) liste.reverse();
    for (var i = 0; i < liste.length; i++) {
      try { liste[i].focus(); } catch (e) {}
      if (hatFokus(liste[i])) return;
    }
  }

  // Tab: Richtung merken, Wächter sicherstellen, Theme-Falle abmelden – vor deren eigenem Tastatur-Handler.
  window.addEventListener("keydown", function (e) {
    perTastatur = true;
    if (e.key !== "Tab") return;
    rueckwaerts = e.shiftKey;
    var s = offeneSchublade();
    if (!s) return;
    waechterSetzen(s);
    themeFalleAbmelden();
  }, true);
  window.addEventListener("pointerdown", function () { perTastatur = false; }, true);

  document.addEventListener("open", function (e) {
    if (!e.target || e.target.id !== SCHUBLADE_ID) return;
    waechterSetzen(e.target);
    themeFalleAbmelden();
  }, true);

  document.addEventListener("focusin", function (e) {
    var ziel = e.target;
    var s = offeneSchublade();
    if (!s) {
      var zu = document.getElementById(SCHUBLADE_ID);
      if (ziel && ziel !== document.body && !(zu && zu.contains(ziel))) zuletztAussen = ziel;
      return;
    }
    if (ziel.hasAttribute && ziel.hasAttribute("data-tp-fokus-waechter")) {
      fokusNach(s, ziel.getAttribute("data-tp-fokus-waechter") === "anfang");
      return;
    }
    if (!s.contains(ziel)) {
      // Fokus ist auf die Seite dahinter gerutscht: nach dem Schließen ist das gewollt, sonst zurück in die Schublade.
      window.setTimeout(function () {
        var offen = offeneSchublade();
        var aktiv = document.activeElement;
        if (offen && aktiv && aktiv !== document.body && !offen.contains(aktiv)) fokusNach(offen, rueckwaerts);
      }, 0);
    }
  }, true);

  document.addEventListener("close", function (e) {
    var s = e.target;
    if (!s || s.id !== SCHUBLADE_ID || !perTastatur) return;
    var aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && !s.contains(aktiv)) return;
    if (zuletztAussen && zuletztAussen.isConnected && !s.contains(zuletztAussen)) {
      try { zuletztAussen.focus({ preventScroll: true }); } catch (x) {}
    }
  }, true);

  // e) tom&pat 10.3 (Theo, 10.10.2026, Rundgang Aufgabe 63, Fietes axe-Prüfung nach 10.0): Schieber (Flickity aus
  //    vendor.js) in der Produktgalerie und bei den Kundenstimmen der Startseite. Aussehen und Bedienung mit Maus/Finger
  //    bleiben gleich.
  //    - Galerie: Flickity legt die Bilder in eine eigene Schiene (.flickity-slider) und hängt die Pfeilknöpfe an die
  //      Galerie selbst. Die Galerie trug role="list" – damit standen Knöpfe in einer Liste (axe „aria-required-children“,
  //      kritisch). Die Listen-Rolle wandert auf die Schiene, solange der Schieber läuft; ohne Schieber zurück.
  //    - Galerie: Verdeckte Bilder (aria-hidden="true" von Flickity) enthalten den Zoom-Knopf; per Tab erreichbar, aber
  //      für Screenreader unsichtbar (axe „aria-hidden-focus“). Diese Knöpfe sind jetzt nur aus der Tab-Folge genommen
  //      (tabindex="-1"), solange das Bild verdeckt ist; per Skript (z. B. Rücksprung aus der Großansicht) bleiben sie
  //      fokussierbar.
  //    - Kundenstimmen: Die blassen Nachbar-Karten links und rechts (aria-hidden) sind jetzt „inert“: nicht per Tab
  //      erreichbar und als inaktiv markiert (axe „aria-hidden-focus“ und Kontrast 1,57–1,85:1 nur in diesen blassen
  //      Karten). Wischen und Pfeile laufen weiter über den Schieber; Links darin gehen erst, wenn die Karte vorne ist.
  var GALERIE = "flickity-component.f-product__media-list";
  var IN_ZELLE_FOKUSIERBAR = "a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex^='-']), [data-tp-tab]";

  function istKundenstimme(zelle) {
    return zelle.classList.contains("f-column") && !!zelle.querySelector(".f-testimonial") && !!zelle.closest("flickity-component");
  }
  function istGalerieZelle(zelle) {
    return zelle.classList.contains("f-product__media") && !!zelle.closest(GALERIE);
  }

  function galerieRolle(galerie) {
    if (!galerie) return;
    var schiene = galerie.querySelector(":scope > .flickity-viewport > .flickity-slider");
    if (schiene) {
      if (galerie.getAttribute("role") === "list") {
        galerie.removeAttribute("role");
        galerie.setAttribute("data-tp-rolle", "list");
      }
      if (galerie.hasAttribute("data-tp-rolle") && schiene.getAttribute("role") !== "list") schiene.setAttribute("role", "list");
    } else if (galerie.getAttribute("data-tp-rolle") === "list") {
      galerie.setAttribute("role", "list");
      galerie.removeAttribute("data-tp-rolle");
    }
  }

  function zelleAbgleichen(zelle) {
    var verdeckt = zelle.getAttribute("aria-hidden") === "true";
    if (istKundenstimme(zelle)) {
      if (zelle.inert !== verdeckt) zelle.inert = verdeckt;
      return;
    }
    if (!istGalerieZelle(zelle)) return;
    zelle.querySelectorAll(IN_ZELLE_FOKUSIERBAR).forEach(function (el) {
      if (verdeckt) {
        if (!el.hasAttribute("data-tp-tab")) el.setAttribute("data-tp-tab", el.hasAttribute("tabindex") ? el.getAttribute("tabindex") : "");
        el.setAttribute("tabindex", "-1");
      } else if (el.hasAttribute("data-tp-tab")) {
        var vorher = el.getAttribute("data-tp-tab");
        el.removeAttribute("data-tp-tab");
        if (vorher === "") el.removeAttribute("tabindex");
        else el.setAttribute("tabindex", vorher);
      }
    });
  }

  function schieberAbgleichen() {
    document.querySelectorAll(GALERIE).forEach(function (galerie) {
      galerieRolle(galerie);
      galerie.querySelectorAll(".f-product__media").forEach(zelleAbgleichen);
    });
    document.querySelectorAll("flickity-component .f-column").forEach(function (zelle) {
      if (istKundenstimme(zelle)) zelleAbgleichen(zelle);
    });
  }

  // Flickity setzt/entfernt aria-hidden beim Start, bei jedem Wechsel und beim Abbauen (Wechsel Handy/Tablet).
  if (window.MutationObserver) {
    new MutationObserver(function (eintraege) {
      var galerien = [];
      for (var i = 0; i < eintraege.length; i++) {
        var el = eintraege[i].target;
        if (el.nodeType !== 1) continue;
        if (el.classList.contains("f-product__media") || el.classList.contains("f-column")) zelleAbgleichen(el);
        var g = el.closest && el.closest(GALERIE);
        if (g && galerien.indexOf(g) < 0) galerien.push(g);
      }
      galerien.forEach(galerieRolle);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ["aria-hidden"], subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schieberAbgleichen);
  else schieberAbgleichen();
  document.addEventListener("shopify:section:load", schieberAbgleichen);
  window.setTimeout(schieberAbgleichen, 1500);

  // f) tom&pat 10.3 (Theo, 10.10.2026, Rundgang Aufgabe 78, Galerie-Rest): Der Zaehler unter der Produktgalerie am Handy
  //    ("1 / 11", snippets/product-media.liquid) nannte als Gesamtzahl immer alle Bilder des Produkts (product.media.size).
  //    Der Varianten-Bildfilter (foxecom-bs-kit, assets/product-info.js) zeigt aber je Ausfuehrung nur einen Teil
  //    (Menstruationsschwamm ohne Faden 7, mit Faden 5). Die Gesamtzahl folgt jetzt den Bildern, die der Schieber wirklich
  //    zeigt, die laufende Nummer dem gewaehlten Bild - beim Laden, nach jedem Variantenwechsel und beim Umbau des Schiebers.
  //    Gilt auch fuer den Vorlesetext ("1 von 7"). Ohne Bildfilter (z. B. Honeycomb) bleibt die Zahl wie bisher.
  function zaehlerAbgleichen(galerie) {
    var gesamt = galerie.querySelector(".flickity-counter--total");
    if (!gesamt) return;
    var fl = window.FoxTheme && window.FoxTheme.Flickity && window.FoxTheme.Flickity.data(galerie);
    var aktiv = !!(fl && fl.isActive && fl.cells);
    var zahl = aktiv ? fl.cells.length : galerie.querySelectorAll(".f-product__media").length;
    if (zahl > 0 && gesamt.textContent.trim() !== String(zahl)) gesamt.textContent = String(zahl);
    var jetzt = galerie.querySelector(".flickity-counter--current");
    if (jetzt && aktiv && typeof fl.selectedIndex === "number") {
      var nr = String(fl.selectedIndex + 1);
      if (jetzt.textContent.trim() !== nr) jetzt.textContent = nr;
    }
  }

  var zaehlerGeplant = false;
  function zaehlerAlle() {
    zaehlerGeplant = false;
    document.querySelectorAll(GALERIE).forEach(zaehlerAbgleichen);
  }
  function zaehlerPlanen() {
    if (zaehlerGeplant) return;
    zaehlerGeplant = true;
    window.setTimeout(zaehlerAlle, 60);
  }
  function zaehlerBeobachten() {
    document.querySelectorAll(GALERIE).forEach(function (galerie) {
      if (galerie.hasAttribute("data-tp-zaehler") || !galerie.querySelector(".flickity-counter--total")) return;
      galerie.setAttribute("data-tp-zaehler", "");
      // Der Bildfilter nimmt Bilder aus der Schiene und haengt die passenden wieder an (Flickity remove/append).
      if (window.MutationObserver) new MutationObserver(zaehlerPlanen).observe(galerie, { childList: true, subtree: true });
    });
    zaehlerPlanen();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", zaehlerBeobachten);
  else zaehlerBeobachten();
  document.addEventListener("variant:changed", zaehlerPlanen);
  document.addEventListener("shopify:section:load", zaehlerBeobachten);
  window.setTimeout(zaehlerAlle, 1500);
})();
